import * as S from './Header.styled';
import { Buttons } from 'components';

const Header = ({ excludeLength, includeLength, clearIncludeItems, clearExcludeItems }) => {
  return (
    <S.Container>
      <S.Section field='include'>
        <span>Include:</span>
        {includeLength ? (
          <Buttons.TertiarySmall id='clearAllBtn' onClick={clearIncludeItems}>
            Clear All
          </Buttons.TertiarySmall>
        ) : null}
      </S.Section>
      {excludeLength ? (
        <S.Section field='exclude'>
          <span>Exclude:</span>
          <Buttons.TertiarySmall id='clearAllBtn' onClick={clearExcludeItems}>
            Clear All
          </Buttons.TertiarySmall>
        </S.Section>
      ) : null}
    </S.Container>
  );
};

export default Header;
